<!-- Şubenin para birimi bazında bakiyesi. app-kpi-card temaya göre çizilir
     (modern: .m-kpi, klasik: Skote mini-stats-wid). Ana değer toplam bakiye; kasa ve
     müşteri bakiyesi ek değer. Karttaki "+" düğmesi o para biriminde hareket ekler. -->
<div class="row row-cols-1 row-cols-sm-2 row-cols-lg-4 row-cols-xxl-5 g-3 mb-3" *ngIf="hasUserRole && cards.length">
  <div class="col" *ngFor="let card of cards">
    <app-kpi-card [label]="card.label" [value]="card.value" [icon]="card.icon" [tone]="card.tone"
                  [extras]="card.extras" comparison="Toplam bakiye"
                  actionIcon="bx bx-plus" actionTitle="Hareket Ekle"
                  (action)="openAccountTransactionAddModal(card.currency)">
    </app-kpi-card>
  </div>
</div>
